import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Settings } from '@mui/icons-material';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';
import LogoutIcon from '@mui/icons-material/Logout';
import {
  Box,
  CardActionArea,
  Divider,
  IconButton,
  MenuItem,
  MenuList,
  Popover,
  Tooltip,
  Typography,
} from '@mui/material';
import { useParties } from '../../contexts/PartiesContext';
import { useUserState } from '../../contexts/UserContext';
import { TextInputLabel } from '../Form/TextInput';
import { useCopyToClipboard } from '../useCopyToClipboard';

export const ProfilePopover: React.FC = () => {
  const [anchorEl, setAnchorEl] = React.useState<HTMLButtonElement | null>(null);
  const { party } = useParties();
  const navigate = useNavigate();
  const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
    setAnchorEl(event.currentTarget);
  };
  const open = Boolean(anchorEl);
  const handleClose = () => {
    setAnchorEl(null);
  };
  const toSettings = () => {
    navigate('/settings', { state: { pageName: 'Settings' } });
    handleClose();
  };
  const id = open ? 'simple-popover' : undefined;
  const { loggedInUser, logout } = useUserState();
  const copy = useCopyToClipboard();
  const onCopyPartyId = () => {
    copy(party);
  };
  const onLogout = () => {
    logout()
      .then(() => {})
      .catch((e) => console.error(e));
  };

  return (
    <>
      <Tooltip title="Account & settings">
        <IconButton
          aria-label="account"
          sx={{ display: 'flex', alignItems: 'center', p: 0.5 }}
          onClick={handleClick}
        >
          <AccountCircleIcon />
        </IconButton>
      </Tooltip>
      <Popover
        id={id}
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
      >
        <Box sx={{ maxWidth: '300px', p: 2 }}>
          <Box sx={{ mt: 1 }}>
            <TextInputLabel label="Party ID" />
            <CardActionArea
              onClick={onCopyPartyId}
              sx={{
                textWrap: 'wrap',
                cursor: 'pointer',
                border: (t) => `1px solid ${t.palette.divider}`,
                p: 1,
                borderRadius: 2,
                position: 'relative',
              }}
            >
              <Tooltip title="Click to copy">
                <Typography
                  variant="caption"
                  sx={{ wordBreak: 'break-word', fontFamily: 'monospace' }}
                >
                  {party}
                </Typography>
              </Tooltip>
              <ContentCopyIcon
                color="action"
                sx={{ position: 'absolute', right: 4, bottom: 4 }}
                fontSize="small"
              />
            </CardActionArea>
            <Box sx={{ mt: 1 }}>
              <TextInputLabel label="User ID" />
              <Typography>{loggedInUser?.userId}</Typography>
            </Box>
          </Box>
        </Box>
        <Divider />
        <MenuList>
          <MenuItem onClick={toSettings}>
            <Settings fontSize="small" sx={{ mr: 1 }} />
            <Typography variant="body2">Settings</Typography>
          </MenuItem>
          <MenuItem aria-label="Log out" onClick={onLogout}>
            <LogoutIcon color="error" fontSize="small" sx={{ mr: 1 }} />
            <Typography color="error" variant="body2">
              Log out
            </Typography>
          </MenuItem>
        </MenuList>
      </Popover>
    </>
  );
};
